import { type SxProps, type Theme } from "@mui/material/styles";

import { Tooltip, type TooltipPlacement } from "ui/tooltip";

import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";

import { getDisabledActionMessage } from "containers/admin/clients/touchpoint/tab-components/preview-tab/components/preview-tab-header/disabled-action-tooltip/disabled-action-tooltip-message";

interface DisabledActionTooltipProps {
  isBlockedByLock: boolean;
  isBlockedByInvalidFields: boolean;
  isBlockedByOpenActionItems: boolean;
  selectedVersion?: TouchpointVersionAttributes;
  handleOpenContentSettings: () => void;
  setIsActionsMenuOpen: (open: boolean) => void;
}

const TOOLTIP_SX: SxProps<Theme> = { textAlign: "center" };

function DisabledActionTooltip({
  isBlockedByLock,
  isBlockedByInvalidFields,
  isBlockedByOpenActionItems,
  selectedVersion,
  handleOpenContentSettings,
  setIsActionsMenuOpen,
}: DisabledActionTooltipProps) {
  const result = getDisabledActionMessage({
    isBlockedByLock,
    isBlockedByInvalidFields,
    isBlockedByOpenActionItems,
    selectedVersion,
    handleOpenContentSettings,
    iconClassName: "ml-1",
  });

  if (!result) return null;

  return (
    <Tooltip
      placement={"bottom" as TooltipPlacement}
      width={256}
      sx={TOOLTIP_SX}
      onMouseEnter={() => setIsActionsMenuOpen(false)}
      label={result.message}
    >
      {result.icon}
    </Tooltip>
  );
}

export default DisabledActionTooltip;
